const routes = [
    {
        path: "/housing/reservations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'housingreservation_index'
        }
    }
];

export default routes;
